<app-onboarding-stepper>
  @for (slide of data.slides; track slide.slideId) {
    <cdk-step>
      <app-onboarding-slide
        class="onboarding-page"
        (closeDialog)="onClose()"
        [onboardingData]="slide"
        [isLast]="$last"
        [currentIndex]="$index"
        [length]="data.slides.length"
      />
    </cdk-step>
  }
</app-onboarding-stepper>
